uic-output {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  max-width: 300px;
  padding: 0 8px 8px;
  position: relative;
}

.uic-output {
  &__label {
    @include font(normal);
    @include truncate();
    border-bottom: 1px solid var(--uic-color-grey2);
    padding-bottom: 4px;
    padding-top: 2px;
    text-align: left;
  }

  &__content {
    display: flex;
    flex-direction: row;
  }

  &__value {
    @include font(medium, semibold);
    flex: 1;
    // 39px is desired height of row (40px) without height of border atop (1px)
    margin: calc((39px - var(--uic-line-height-medium)) / 2) 0;

    &:not(.uic-output__value--multiline) {
      @include truncate();
    }

    &--max-lines {
      -webkit-box-orient: vertical; /* stylelint-disable-line property-no-vendor-prefix */
      display: -webkit-box; /* stylelint-disable-line value-no-vendor-prefix */
      hyphens: auto;
      overflow: hidden;
    }
  }

  &__unit {
    @include font(normal);
    padding-left: 8px;
    user-select: none;
  }

  &__flag {
    display: none;
    margin: 1px 4px 0 1px;

    svg {
      height: var(--uic-icon-height);
      width: var(--uic-icon-width);
    }
  }
}

uic-output[flag] {
  .uic-output__flag {
    display: block;
  }
}

uic-output[flag][align='right'] {
  .uic-output__content {
    flex-direction: row-reverse;
  }
}

uic-output[variant='copytext'] {
  .uic-output__value {
    @include font(normal, normal);

    .uic-output__value--multiline,
    .uic-output__value--max-lines {
      padding-top: 5px;
    }

    &:not(.uic-output__value--multiline):not(.uic-output__value--max-lines) {
      @include truncate();
      // 39px is desired height of row (40px) without height of border atop (1px)
      margin: calc((39px - var(--uic-line-height-normal)) / 2) 0;
    }

    &:not(.uic-output__value--max-lines) {
      overflow: visible;
      text-overflow: clip;
      white-space: pre-wrap;
    }
  }
}

uic-output[align='right'] {
  .uic-output__content {
    text-align: right;
  }
}
